import { utils, writeFile } from 'xlsx';
import { ProductsNotSearched, ResearchedProduct } from '@/types/MarketResearch';
import { structData } from '.';

export const useProductMarketResearchSpreadsSheet = () => {
  const getTableRowsCycle = (positionData: ResearchedProduct[]) =>
    positionData.map((row) => {
      const obj = {} as Record<string, any>;

      obj['Revenda'] = row.DS_REVENDA ?? '';
      obj['Representante'] = row.NM_USUARIO ?? '';
      obj['Codigo Cliente'] = row.NK_CLIENTE ?? row.SK_CLIENTE ?? '';
      obj['Razao Social completa'] = row.DS_RAZAO_SOCIAL ?? '';
      obj['PDV'] = row.DS_NOME_FANTASIA ?? '';
      obj['Produto'] = row.DS_PRODUTO ?? '';
      obj['Vl. Compra'] =
        row.VL_PRECO_COMPRA !== null && row.VL_PRECO_COMPRA !== undefined
          ? Number(row.VL_PRECO_COMPRA)
          : null;
      obj['Qtd. Compra'] =
        row.QTD_VOLUME_COMPRA !== null && row.QTD_VOLUME_COMPRA !== undefined
          ? Number(row.QTD_VOLUME_COMPRA)
          : null;
      obj['Vl. Venda'] =
        row.VL_PRECO_VENDA !== null && row.VL_PRECO_VENDA !== undefined
          ? Number(row.VL_PRECO_VENDA)
          : null;
      obj['Motivo nao pesquisa'] = row.DS_MOTIVO_NAO_PESQUISA ?? '';
      obj['Status Lançamento'] = row.DD_STATUS ?? '';
      obj['Dt. Publicação'] = row.DT_PUBLICACAO
        ? new Date(row.DT_PUBLICACAO)
        : null;
      return obj;
    });

  const getTableRowsProductsNotSearched = (
    productsNotSearched: ProductsNotSearched[],
  ) =>
    productsNotSearched.map((row) => {
      const obj = {} as Record<string, any>;

      obj['Revenda'] = row.DS_REVENDA ?? '';
      obj['Representante'] = row.NM_FUNCIONARIO ?? '';
      obj['Codigo Cliente'] = row.NK_CLIENTE ?? row.SK_CLIENTE ?? '';
      obj['Razao Social completa'] = row.DS_RAZAO_SOCIAL ?? '';
      obj['Cliente'] = row.DS_NOME_FANTASIA ?? '';
      obj['Produto'] = row.DS_PRODUTO ?? '';
      return obj;
    });

  const onDownload = (
    structData: structData[],
    dataProductsNotSearched: ProductsNotSearched[],
  ) => {
    const workbook = utils.book_new();

    structData.forEach((cycle) => {
      const rows = getTableRowsCycle(cycle.dataResearchedProducts);

      const formatDate = 'dd/mm/yyyy hh:mm';
      const formatMoneyAccounting =
        '_-* #,##0.00_-;-* #,##0.00_-;_-* "-"??_-;_-@_-';

      const worksheet = utils.aoa_to_sheet([[]]);

      if (rows.length > 0) {
        utils.sheet_add_json(worksheet, rows, {
          origin: { r: 0, c: 0 },
        });

        const headers = Object.keys(rows[0]);
        const vlCompraColIdx = headers.indexOf('Vl. Compra');
        const vlVendaColIdx = headers.indexOf('Vl. Venda');
        const dtPublicacaoColIdx = headers.indexOf('Dt. Publicação');

        for (let r = 1; r <= rows.length; r++) {
          if (vlCompraColIdx !== -1) {
            const cellRef = utils.encode_cell({ r, c: vlCompraColIdx });
            if (worksheet[cellRef])
              worksheet[cellRef].z = formatMoneyAccounting;
          }
          if (vlVendaColIdx !== -1) {
            const cellRef = utils.encode_cell({ r, c: vlVendaColIdx });
            if (worksheet[cellRef])
              worksheet[cellRef].z = formatMoneyAccounting;
          }
          if (dtPublicacaoColIdx !== -1) {
            const cellRef = utils.encode_cell({ r, c: dtPublicacaoColIdx });
            if (worksheet[cellRef]) worksheet[cellRef].z = formatDate;
          }
        }

        worksheet['!cols'] = headers.map((header) => {
          if (header === 'Razao Social completa' || header === 'Razão Social') {
            return { wch: 35 };
          }
          if (
            [
              'Revenda',
              'Representante',
              'PDV',
              'Cliente',
              'Produto',
              'Motivo nao pesquisa',
            ].includes(header)
          ) {
            return { wch: 25 };
          }
          if (header === 'Dt. Publicação') {
            return { wch: 20 };
          }
          return { wch: 15 };
        });
      }

      utils.book_append_sheet(workbook, worksheet, `${cycle.cycle}`);
    });

    const worksheet = utils.aoa_to_sheet([[]]);
    const rows = getTableRowsProductsNotSearched(dataProductsNotSearched);
    if (rows.length > 0) {
      utils.sheet_add_json(worksheet, rows, {
        origin: { r: 0, c: 0 },
      });

      const headers = Object.keys(rows[0]);
      worksheet['!cols'] = headers.map((header) => {
        if (header === 'Razao Social completa' || header === 'Razão Social') {
          return { wch: 35 };
        }
        if (
          ['Revenda', 'Representante', 'PDV', 'Cliente', 'Produto'].includes(
            header,
          )
        ) {
          return { wch: 25 };
        }
        return { wch: 15 };
      });
    }

    utils.book_append_sheet(workbook, worksheet, `Pendentes de pesquisa`);

    const currentDate = new Date();
    const day = currentDate.getDate().toString().padStart(2, '0');
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const year = currentDate.getFullYear().toString();
    const currentDateFormated = day + month + year;

    writeFile(workbook, `Pesquisa_${currentDateFormated}.xlsx`, {
      compression: true,
      cellStyles: true,
    });
  };

  return {
    onDownload,
  };
};
